<script setup>
</script>
<template>
  <div>
    <h1>eBay</h1>

    <ul class="nav nav-tabs mb-4">
      <li class="nav-item">
        <router-link :to="{ name: 'AdminEbayCategories' }" class="nav-link" active-class="active">
          Categories
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{ name: 'AdminEbayApiHealth' }" class="nav-link" active-class="active">
          API Health
        </router-link>
      </li>
    </ul>
    <router-view />
  </div>
</template>
